import React from 'react';
import { Link } from 'react-router-dom';
import ScrollAnimation from './ScrollAnimation';
import { proyectosDestacados } from '../data/proyectos';

const PortfolioSummary: React.FC = () => (
    <section id="trabajos" className="py-16 bg-white">
        <div className="container mx-auto px-6">
            <ScrollAnimation>
                <h2 className="text-3xl font-bold font-poppins text-grafito mb-4 text-center">
                    Trabajos realizados
                </h2>
            </ScrollAnimation>
            <ScrollAnimation delay={0.1}>
                <p className="text-center text-gray-600 font-lato max-w-2xl mx-auto mb-12">
                    Lo último que construimos. Cada uno tiene su ficha: qué nos pidieron, qué hicimos
                    y cómo funciona hoy.
                </p>
            </ScrollAnimation>

            <div className="max-w-6xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                    {proyectosDestacados.map((p, index) => (
                        <ScrollAnimation key={p.slug} delay={0.2 + index * 0.1}>
                            <Link
                                to={`/portafolio/${p.slug}`}
                                className="group h-full flex flex-col bg-gray-50 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                            >
                                <div className="h-48 bg-gray-200 overflow-hidden">
                                    <img
                                        src={p.imagen}
                                        alt={p.titulo}
                                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                </div>
                                <div className="p-6 flex flex-col flex-grow">
                                    <span className="self-start px-3 py-1 bg-cyan text-white text-xs font-montserrat rounded-full mb-3">
                                        {p.categoria}
                                    </span>
                                    <h3 className="text-xl font-semibold font-montserrat text-grafito mb-2 group-hover:text-cyan transition-colors">
                                        {p.titulo}
                                    </h3>
                                    <p className="text-gray-600 font-lato text-sm mb-4">{p.resumen}</p>
                                    <span className="mt-auto inline-flex items-center text-sm font-montserrat font-semibold text-cyan">
                                        Ver el caso
                                        <svg className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                        </svg>
                                    </span>
                                </div>
                            </Link>
                        </ScrollAnimation>
                    ))}
                </div>

                <ScrollAnimation>
                    <div className="text-center">
                        <Link
                            to="/portafolio"
                            className="inline-flex items-center px-6 py-3 bg-cyan text-white font-montserrat font-semibold rounded-lg hover:bg-opacity-90 transition-colors shadow-md hover:shadow-lg"
                        >
                            Ver todos los trabajos
                            <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                            </svg>
                        </Link>
                    </div>
                </ScrollAnimation>
            </div>
        </div>
    </section>
);

export default PortfolioSummary;
